<template>
  <v-container class="fill-height" fluid>
    <v-row align="center" justify="center">
      <v-progress-circular indeterminate class="primary--text" :width="5" :size="100" />
    </v-row>
  </v-container>
</template>
<script>
  import { apiResource } from '@/util/resources'

  export default {
    props: ['requestId', 'taskId'],
    created () {
      this.verifySigning()
    },
    methods: {
      verifySigning () {
        this.$store.commit('setLoading', true)
        this.$store.commit('clearError')
        this.$store.commit('setVerdictLoading', true)

        var data = {
          Email: this.verdictData.Email,
          IsMandatory: this.verdictData.IsMandatory,
          RequestId: this.requestId,
          TaskId: this.taskId,
          Lang: this.$store.getters.longLocale
        }

        apiResource.post('api/judgement/verify', data).then((response) => {
          this.$store.commit('setLoading', false)
          this.$router.push('/front-page')
          this.$store.commit('setShowVerdictSentDialog', true)
          
          this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Auth Completed")
          this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Succesful")
        }).catch((error) => {
          if (error.response.data === 'aborted') {
            this.$store.commit('setMessage', { type: 'error', text: 'error.reconciliation.0', translate: true })
            this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Auth Canceled")
          } else if (error.response.data === 'error') {
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
            this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Auth Failed")
          } else {
            this.$store.commit('setMessage', { type: 'error', text: 'error.server.0', translate: true })
            this.$matomo && this.$matomo.trackEvent("Action", "Download Court's Decision", "Decision Auth Failed")
          }

          this.$store.commit('setLoading', false)
          this.$router.push('/front-page')
          this.$store.commit('setVerdictLoading', false)
        })
      }
    },
    computed: {
      verdictData () {
        return this.$store.getters.verdictData
      }
    }
  }
</script>
